<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.companyInfo.title"> </sm-page-header>
  <div class="content">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-dialog #dialog [dialog]="companyDialog"></sm-dialog>
</div>
